import {twoArrayHaveSameElement} from "@app/utils/CommonUtils";
import {CommonUseFields, ResponseCode} from "@app/constants/Common";
import * as CommonUtils from "@app/utils/CommonUtils";
import * as EmailUtils from "@app/utils/EmailUtils";
import {Messages, showMessage} from "@app/constants/Messages";
import {requestFetchDicts} from "@app/services/ExtractService";
import {requestSubmitPriorityInputNotes} from "@app/services/UserService";
import {toast} from "react-toastify";

export const checkExistsCommonFieldValues = (candidate={}, userLoginId) => {
    const fields = (candidate.fields && candidate.fields.length > 0) ? candidate.fields : Object.keys(candidate)
    if (fields && fields.length > 0) {
        for (let i=0; i < fields.length; i++) {
            const f = fields[i]
            const commonField = CommonUseFields[f]
            if (commonField && !commonField.notUnique) {
                const parentField = commonField.parent
                const otherInputs = candidate[parentField]
                let arrOtherUserInputs = []
                if (otherInputs) {
                    otherInputs.forEach(oin => {
                        // Check xem nếu có thông tin đã đc nhập trong pm và là của user khác user đang login.
                        if (oin[f] && oin.created_user !== userLoginId) {
                            arrOtherUserInputs = [...arrOtherUserInputs, ...CommonUtils.toArray(oin[f])]
                        }
                    })
                    if (twoArrayHaveSameElement(CommonUtils.toArray(candidate[f]), arrOtherUserInputs)) {
                        showMessage(`Dữ liệu ${commonField.title} trùng với dữ liệu đã được nhập bởi user khác.`)
                        return true
                    }
                }
            }
        }
    }
    return false
}

export const processWithoutPersonalEmail = async (emails) => {
    const resPersonalEmails = await requestFetchDicts('personal_email');
    const standardPersonalEmails = resPersonalEmails.content ? resPersonalEmails.content.split("\n") : []
    if (standardPersonalEmails.length > 0 && !EmailUtils.validatePersonalEmails(emails, standardPersonalEmails)) {
        if (window.confirm(Messages.confirmNextProcessWithNotPersonalEmail) === false) {
            return false
        }
    }
    return true
}


export const confirmSubmitNotesWhenInputInPriorityTimeRange = (priorityNotifyId) => {
    let priorityConfirm = prompt(Messages.inputInPriorityTimeRange, "");
    if (priorityConfirm) {
        //Gửi thông tin note về ứng viên trong thời gian NL ưu tiên
        let requestBody = {
            notes: priorityConfirm,
            notify_id: priorityNotifyId,
        }
        requestSubmitPriorityInputNotes(requestBody).then(res1 => {
            if (res1.sts_code === ResponseCode.SUCCESS) {
                toast.success(`Submit thông tin Notes ứng viên thành công.`);
            } else {
                toast.error(`Submit thông tin Notes ứng viên thất bại.`);
            }
        });
    }
}

/**
 * 3 trường của card "Giới tính" là thông tin 1 giá trị, dùng chung giữa các user.
 * Resolve từ TOÀN BỘ bản ghi Personal USER_INPUT của UV (response của
 * GET /candidate/input-info?input_type=Personal — API này không filter created_user).
 *
 * Quy tắc bám theo tiền lệ backend CandidateService.py:1145-1177 (build personal cho email):
 *  - gender:               dùng chung — của mình trước, chưa có thì của user khác (updated mới nhất)
 *  - caller_name_to_email: của mình trước, chưa có thì suy từ gender dùng chung
 *  - vocative:             của mình trước, chưa có thì lấy tên user đang login (lowercase để
 *                          khớp value của <option> trong GenderCard). Chỉ fallback khi đã biết
 *                          gender, để UV chưa có dữ liệu giới tính giữ nguyên hiển thị rỗng.
 *
 * BUGFIX TASK-TEST-G-I-EMAIL-QUA-1786372420029: fallback của caller_name_to_email/vocative
 * chỉ được áp dụng khi user CHƯA TỰ chọn `gender` cho mình (đang dùng gender dùng chung của
 * user khác, tức chưa thực sự quyết định gì cho card này) — dùng để gợi ý giá trị mặc định
 * lần đầu. Một khi user đã tự chọn `gender` của mình, caller_name_to_email/vocative rỗng
 * nghĩa là user CHỦ ĐÍCH để trống (không có preference riêng) — KHÔNG được tự suy diễn đè lên,
 * nếu không mỗi lần refresh sẽ ghi đè lựa chọn "để trống" của user thành 1 giá trị đoán được.
 *
 * Hàm thuần: không đọc localStorage, không gọi API → test được trực tiếp.
 */
export const resolveGenderCardPersonal = ({
    allPersonalRows = [],
    loginUserId,
    loginUserName = '',
} = {}) => {
    const rows = [...allPersonalRows].sort((a, b) =>
        String(b.updated_date_time || '').localeCompare(String(a.updated_date_time || ''))
    )
    const ownRow = rows.find(row => row.created_user === loginUserId) || {}
    const hasOwnGender = !!ownRow.gender

    // TASK-TEST-G-I-EMAIL-QUA-1786372420029: khi gender hiển thị không phải của
    // chính user login, trả kèm ai đã nhập để GenderCard render "Nhập bởi: {tên}".
    let genderInputBy = null
    let gender = ownRow.gender || ''
    if (!gender) {
        const otherRow = rows.find(row => row.gender) || {}
        gender = otherRow.gender || ''
        if (gender) {
            genderInputBy = { id: otherRow.created_user, name: otherRow.created_user_name || '' }
        }
    }

    let callerNameToEmail = ownRow.caller_name_to_email || ''
    if (!hasOwnGender && !callerNameToEmail) {
        const genderKey = CommonUtils.stringToLowerCase(gender).trim()
        if (genderKey === 'nam') {
            callerNameToEmail = 'anh'
        } else if (genderKey === 'nữ') {
            callerNameToEmail = 'chị'
        }
    }

    let vocative = ownRow.vocative || ''
    if (!hasOwnGender && !vocative && gender) {
        vocative = CommonUtils.stringToLowerCase(loginUserName)
    }

    return { gender, caller_name_to_email: callerNameToEmail, vocative, genderInputBy }
}